module.exports = __webpack_public_path__ + "media/brands/solaris-ca274521.png";